import { AssetRunDryInfo } from "@hydrologiq/gql/graphql"
import Figure, { FigureProps } from "./Figure"
import FigureContent from "./FigureContent"
import { Link } from "@hydrologiq/shared/components/Link"
import { Asset } from "@hydrologiq/gql-experience/graphql"
import { formatRunDryMinutes } from "@hydrologiq/shared/asset/attributes/RunDry"
import { useIsSectionEnabled } from "@hydrologiq/shared/providers/SectionFeatures"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

export interface TimeToDepletionProps extends FigureProps {
  minutes?: number
  location?: string
  asset?: Asset
  granularity?: "hours" | "days"
  customer?: string
  site?: string
  info?: AssetRunDryInfo
}

const TimeToDepletion = ({ minutes, location, asset, customer, site, granularity = "hours", isPlaceholder, ...rest }: TimeToDepletionProps) => {
  const isCustomersEnabled = useIsSectionEnabled("customers")

  const locationLink = customer && site ? (
    <Link href={`/customers/${customer}/sites/${site}`} fontSize="xs" tooltip={location} deLink={!isCustomersEnabled}>{location}</Link>
  ) : asset ? (
    <Link href={`/assets/${asset.id}`} fontSize="xs" tooltip={asset.name}>{asset.name}</Link>
  ) : location ? (
    <FigureContent.Label>{location}</FigureContent.Label>
  ) : undefined

  return (
    <Figure {...rest} isPlaceholder={minutes === undefined || isPlaceholder} compact={isCompactFigure("summary")}>
      <FigureContent.Root>
        <FigureContent.SubText link={locationLink}>estimated</FigureContent.SubText>
        <FigureContent.Value>
          {typeof minutes === "number" ? formatRunDryMinutes(minutes, true) : "pending"}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default TimeToDepletion